const images = {
    cubix: 'https://sofiaxtv2.blob.core.windows.net/imagenes/interfaz/pentathlon/cubix.svg',
    message: 'https://sofiaxtv2.blob.core.windows.net/imagenes/interfaz/pentathlon/mensaje.png'
}

export default images;